// extracted by mini-css-extract-plugin
export var center = "_5f-2";
export var clickableRow = "_5f-5";
export var expandedRow = "_5f-7";
export var hoverable = "_5f-4";
export var left = "_5f-1";
export var right = "_5f-3";
export var row = "_5f-0";
export var selectedRow = "_5f-6";
export var summaryRow = "_5f-8";